import angular from 'angular';
import notificationsConfig from './notificationsConfig.js';
import 'ng-notifications-bar';
import 'ng-notifications-bar/css/ngNotificationsBar.css';
import './notificationsStyles.css';

// for usage see https://github.com/alexbeletsky/ng-notifications-bar
angular.module('sh.notifications', ['ngNotificationsBar', 'ngSanitize']).config(notificationsConfig);
